
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import angol from "../../assets/angol.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"



function MagyarAngol({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar angol fordító</title>
                <meta name='description' content="Ingyenes magyar angol fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar angol fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-angol-fordito" />
            </Helmet>
            <h1>Magyar angol fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és angol nyelv </h2>
                    <img src={magyar} alt="Magyar zászló"></img>
                    <img src={angol} alt="angol zászló"></img>

                </div>


                <p>Íme néhány fő különbség a magyar és az angol között. </p>

                <h3>Ábécé és kiejtés</h3>

                <p>A magyar nyelv fonetikusabb az angolhoz képest, a szavakat úgy ejtik ki, ahogy írják őket. A magyar a magánhangzók és mássalhangzók szélesebb skáláját alkalmazza, mint az angol, általában nyitottabb és hosszabb magánhangzókkal. Bár mindkét nyelv a latin ábécét használja, a magyarban olyan további elemek is találhatók, mint a hosszú magánhangzók (á, é, í, ó, ú), négy diaerézis (ö és ü; ő és ű), „zöngétlen” mássalhangzó-kombinációk (diagramok és trigráfok).</p>

                <p>E hangzásbeli különbségek miatt az angol nyelvű olvasás és írás kihívást jelenthet a magyarok számára. Az olyan problémás szavak, mint a „siker”, amelyek a magyarban hiányzó mássalhangzó-kombinációkat (cc) tartalmaznak, nehézségeket okozhatnak a tanulóknak. Alapvető fontosságú, hogy tisztában legyünk az ilyen problémákkal, és fontoljuk meg a Nemzetközi Fonetikus Abécé (IPA) bevezetését és használatát a tanulók segítése érdekében.</p>

                <p>Különös figyelmet kell fordítani a q, w, x és y betűkre, amelyek a magyarból hiányoznak, de angol kölcsönszavak révén kerültek be az ábécébe. Az angolul tanuló magyarul beszélők gyakran küszködnek a bilabiális "w" mássalhangzó kiejtésével, és akaratlanul is úgy ejtik, mint a dentilabiális "v"-t.</p>

                <h3>Nyelvtan</h3>

                <p>Az angollal ellentétben a magyar agglutináló nyelv, míg az angol ragozott nyelv.

                Például a magyar nyelv nem elöljárószót, hanem utószót használ, ami kihívást jelent a magyar angolul tanulók számára a prepozíciók megértése és helyes használata.</p>

                <p>A magyar főnevek egy gyökből állnak, amelyhez több utótag is hozzáadódik az egyes vagy többes számú alakok (számutótag), a birtoklás (birtokos utótag) és a hely (betűs utótag) jelzésére.</p>

                <p>Az esetek magyarul is jelentős szerepet töltenek be, összesen 17 esettel. Olyan tényezők határozzák meg őket, mint a külső/belső, mozgás/stacionárius, távol/felé stb. Ezek az esetek az angol prepozíciók megfelelőinek tekinthetők.</p>

                <p>A magyar nyelvnek három ideje van: jelen, múlt és jövő. A magyar igék a jelző és a feltételes módokon kívül az angolban szinte kihalt kötőmódban is ragozódnak.</p>

                <p>A magyar nyelvben az igetőhöz toldalékokat adunk az idő, a mód és a tárgy jelzésére, három alakkal egyes számban, három alakkal többes számban.</p>

                <p>A magyar jellemző szórend az angolhoz hasonlóan Tárgy-Ige-Tárgy. A magyar szórendet azonban a "téma" és a "megjegyzés" fogalma is befolyásolja. A téma a mondat ismert részét reprezentálja, míg a megjegyzés új információkat vezet be a témával kapcsolatban. Magyar mondatokban a téma megelőzi a megjegyzést.</p>


                <h3>Szókincs</h3>

                <p>A magyar nyelv alapszókincsét uráli eredetű szavak alkotják. Ez a szempont gyakran jelentős kihívás elé állítja az indoeurópai nyelveket beszélőket, mivel a magyar szavak többsége nem hasonlít a szomszédos országokban beszéltekre.</p>

                <p>A magyar azonban jelentős számú szót kölcsönzött a korai magyar népvándorlások során iráni és türk nyelvekből, később pedig német, olasz, francia, angol és szláv nyelvekből is.</p>

                <div className="sectionbottom">
                    <Link to="/bolgar-magyar-fordito">Angol magyar fordító</Link>
                    <img src={angol} alt="angol zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarAngol;